export const COLLECTIONS = [
  {
    id: "fall-harvest",
    name: "Fall Harvest",
    tagline: "Rich traditional oranges & deep golden yellow",
    description:
      "Classic warm autumn — orange pumpkins, heirloom gourds and autumn mums.",
    colors: ["#C8703F", "#E08A5F", "#D3A03A", "#5C2318"],
    inspiration: true,
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/sfnjg695_IMG_7389.jpeg",
    gallery: [
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/sfnjg695_IMG_7389.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/uy0hz9ex_IMG_7388.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/wlvs6t4b_DC9AAE3F-0FBA-49D1-835C-9C726C70F7C9%20%281%29.png",
    ],
    ourWork: [2],
  },
  {
    id: "cream-and-sage",
    name: "Cream & Sage",
    tagline: "Muted ghostly whites & heirloom grays",
    description:
      "Elevated modern luxury — whites, sage greens and slate blues.",
    colors: ["#F4EEE3", "#7A8B6F", "#BCC4B9", "#2B221D"],
    inspiration: true,
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/in1koevh_IMG_7384.jpeg",
    gallery: [
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/in1koevh_IMG_7384.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/kgd941jy_IMG_7385.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/pzfgc7fv_IMG_7386.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/5427eyg8_IMG_7387.jpeg",
    ],
  },
  {
    id: "english-cottage",
    name: "English Cottage",
    tagline: "Fairytale pumpkins & wild autumn blooms",
    description:
      "Whimsical garden charm — soft pinks, pale greens and trailing ivy.",
    colors: ["#7A8B6F", "#E08A5F", "#F4EEE3", "#5C2318"],
    inspiration: true,
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/ucww242j_IMG_7376.jpeg",
    gallery: [
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/ucww242j_IMG_7376.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/r7ocs3ge_PXL_20261001_010422231.PORTRAIT~2.webp",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/aoz8tvg3_IMG_7801.webp",
    ],
  },
  {
    id: "build-your-own",
    name: "Build Your Own",
    tagline: "Fully à la carte — your palette, your pieces",
    description:
      "Choose your scale and your own pumpkin palette, then add any extra pieces you like. A flat $50 custom palette design consultation is included so we can compose the arrangement around your home ($175 minimum).",
    colors: ["#C8703F", "#F4EEE3", "#7A8B6F", "#8FA0A8", "#B8564A", "#D3A03A"],
    inspiration: true,
    image:
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/50ko536t_IMG_7380.jpeg",
    gallery: [
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/50ko536t_IMG_7380.jpeg",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/kkmqa4vx_FullSizeRender%20%281%29.webp",
      "https://customer-assets-eiarnc6j.emergentagent.net/job_pumpkin-booking/artifacts/pznc62nh_IMG_7381.jpeg",
    ],
  },
];

export const PUMPKIN_COLORS = [
  { id: "orange", label: "Orange", hex: "#D9762F" },
  { id: "white", label: "White", hex: "#F3EEE4" },
  { id: "green", label: "Green / Sage", hex: "#8A9A78" },
  { id: "blue-gray", label: "Blue / Gray", hex: "#8FA0A8" },
  { id: "terracotta", label: "Terra Cotta", hex: "#B5613A" },
  { id: "yellow", label: "Yellow", hex: "#E0B84A" },
  { id: "red", label: "Red", hex: "#A83232" },
  { id: "pink", label: "Pink", hex: "#E3A6A1" },
  { id: "brown", label: "Brown", hex: "#8A5A44" },
  { id: "gourds", label: "Gourds", hex: "#C9B26B" },
];

export const colorLabel = (id) => PUMPKIN_COLORS.find((c) => c.id === id)?.label || id;

export const BYO_TIERS = {
  accent: { pumpkins: "10–14 pumpkins", from: 175, note: "A gentle welcome for a small stoop" },
  standard: { pumpkins: "28–34 pumpkins", from: 359, note: "Our most-loved scale for a typical porch" },
  grand: { pumpkins: "60–70 pumpkins", from: 699, note: "Layered and generous, wide steps and railings" },
  estate: { pumpkins: "130+ pumpkins", from: 1349, note: "A full estate entrance, styled end to end" },
};

export const paletteSummary = (p) => {
  if (!p || !p.colors?.length) return "";
  const names = p.colors.map(colorLabel).join(", ");
  if (p.balance === "custom" && (p.primary || p.accent)) {
    const bits = [p.primary && `mostly ${colorLabel(p.primary)}`, p.accent && `accents of ${colorLabel(p.accent)}`].filter(Boolean).join(", ");
    return `${names} — ${bits}`;
  }
  return `${names} — equal blend`;
};

export const MUM_COLORS = [
  { id: "red", label: "Red", hex: "#A83232" },
  { id: "yellow", label: "Yellow", hex: "#E0B84A" },
  { id: "orange", label: "Orange", hex: "#D9762F" },
  { id: "white", label: "White", hex: "#F3EEE4" },
  { id: "pink", label: "Pink", hex: "#D98BA0" },
  { id: "other", label: "Other", hex: "transparent" },
];
export const mumLabel = (id, other) => (id === "other" ? `Other${other ? ` (${other})` : ""}` : MUM_COLORS.find((c) => c.id === id)?.label || id);

export const addonsSummary = (b) => {
  const parts = Object.entries(b.addons || {}).filter(([, q]) => q > 0).map(([k, q]) => `${itemLabel(k)} × ${q}`);
  const mc = Object.entries(b.mum_colors || {});
  if (mc.length) parts.push(`Mum colors: ${mc.map(([k, v]) => `${mumLabel(k, b.mum_color_other)} ${v}`).join(", ")}`);
  if (b.priority_removal) parts.push("Priority Removal ($75)");
  return parts.length ? parts.join(" · ") : "None";
};

export const SIZES = [
  { id: "accent", label: "Petite" },
  { id: "standard", label: "Standard", popular: true },
  { id: "grand", label: "Grande" },
  { id: "estate", label: "Estate" },
];

const PETITE = ["20 specialty pumpkins", "1 mum", "1 corn stalk bundle"];
const STANDARD = ["40 pumpkins", "2 mums", "1 hay bale", "2 corn stalk bundles"];
const GRANDE = ["80 pumpkins", "4 mums", "2 corn stalk bundles", "2 outdoor lanterns", "2 hay bales"];
const ESTATE = ["120 pumpkins", "8 mums", "4 corn stalk bundles", "4 outdoor lanterns", "4 hay bales"];

export const TIERS = {
  "fall-harvest": {
    accent: { price: 325, includes: PETITE },
    standard: { price: 435, includes: STANDARD },
    grand: { price: 949, includes: GRANDE },
    estate: { price: 1549, includes: ESTATE },
  },
  "cream-and-sage": {
    accent: { price: 425, includes: PETITE },
    standard: { price: 535, includes: STANDARD },
    grand: { price: 1089, includes: GRANDE },
    estate: { price: 1699, includes: ESTATE },
  },
  "english-cottage": {
    accent: { price: 385, includes: PETITE },
    standard: { price: 495, includes: STANDARD },
    grand: { price: 1029, includes: GRANDE },
    estate: { price: 1609, includes: ESTATE },
  },
  "build-your-own": {
    accent: { price: 175, includes: PETITE },
    standard: { price: 359, includes: STANDARD },
    grand: { price: 699, includes: GRANDE },
    estate: { price: 1349, includes: ESTATE },
  },
};
export const PACKAGE_FOOTNOTE = "Every package includes full delivery and professional on-site styling. Everything is yours to keep; post-season removal is available as a Priority Removal add-on.";
export const PRICING_NOTE = "Your total updates as you build. Any change to colors, pieces or package after booking is treated as an addition and carries an extra charge.";

const PUMPKIN_TONES = ["orange", "white", "green", "blue-gray", "terracotta", "yellow", "red", "pink", "brown"];
const toneVariants = (price) => PUMPKIN_TONES.map((c) => ({ id: c, label: colorLabel(c), price }));
const MUM_TONES = [["red", "Red"], ["yellow", "Yellow"], ["orange", "Orange"], ["white", "White"], ["pink", "Pink"], ["purple", "Purple"]];
const mumVariants = () => [["large", "Large mum", 27], ["medium", "Medium mum", 22]].flatMap(([s, section, price]) => MUM_TONES.map(([c, label]) => ({ id: `${s}:${c}`, label, section, price })));

export const ITEMS = [
  { id: "pumpkin", label: "Classic orange pumpkin", price: 5, group: "Pumpkins" },
  { id: "pumpkin_specialty", label: "Specialty pumpkin", group: "Pumpkins", variants: toneVariants(9) },
  { id: "pumpkin_mini", label: "Mini pumpkin", group: "Pumpkins", variants: [{ id: "orange", label: "Orange", price: 4 }, { id: "white", label: "White", price: 4 }, { id: "gourd", label: "Gourd", price: 4 }] },
  { id: "gourd", label: "Gourd", price: 9, group: "Pumpkins" },
  { id: "mum", label: "Mums", group: "Plants", variants: mumVariants() },
  { id: "ivy_accent", label: "Trailing ivy", price: 28, group: "Plants" },
  { id: "basket", label: "Woven basket", price: 30, group: "Accents" },
  { id: "hay_bale", label: "Hay bale", price: 20, group: "Accents" },
  { id: "corn_stalk", label: "Corn stalk bundle", price: 18, group: "Accents" },
  { id: "lantern", label: "Outdoor lantern", price: 36, group: "Accents" },
  { id: "twinkle_lights", label: "Flicker candle", price: 7, group: "Accents" },
  { id: "wreath", label: "Premium door wreath", price: 140, group: "Accents" },
];
const LEGACY_ITEMS = { "pumpkin:small": "Classic orange pumpkin (Small)", "pumpkin:medium": "Classic orange pumpkin (Medium)", "pumpkin:large": "Classic orange pumpkin (Large)", pumpkin_large: "Classic orange pumpkin, large", pumpkin_medium: "Classic orange pumpkin, medium", mum_large: "Large mum", mum_medium: "Medium mum" };
export const itemKey = (item, variant) => (variant ? `${item.id}:${variant.id}` : item.id);
export const itemPrice = (key) => {
  const [base, ...rest] = key.split(":");
  const item = ITEMS.find((i) => i.id === base);
  if (!item) return 0;
  if (!item.variants) return item.price || 0;
  return item.variants.find((v) => v.id === rest.join(":"))?.price || 0;
};
export const itemLabel = (key) => {
  const [base, ...rest] = key.split(":");
  const item = ITEMS.find((i) => i.id === base);
  if (!item) return LEGACY_ITEMS[key] || key;
  if (!item.variants) return item.label;
  const v = item.variants.find((x) => x.id === rest.join(":"));
  if (!v) return item.label;
  return v.section ? `${v.section} (${v.label})` : `${item.label} (${v.label})`;
};
export const REMOVAL_START_LABEL = "November 1st";
export const REMOVAL_WINDOW = { start: "2026-11-01", end: "2026-11-30", label: "November 1 – November 30" };
export const PRIORITY_REMOVAL = { price: 75, title: "Priority Removal", text: `We take everything down for you ${REMOVAL_WINDOW.label}. Pick the date you'd prefer and we'll aim for it — and we guarantee your porch is cleared by December 1.` };
export const BYO = { designFee: 50, minimum: 175, extraPumpkinPrice: 10, extraPumpkinFrom: 130 };
export const PAYMENT_NOTE = "Payment is taken in full at checkout through Stripe's secure payment page. Your date is booked the moment payment clears. Refunds are available up to 5 days before your install.";

export const estimateTotal = (collectionId, size, addons, priority, extraPumpkins = 0) => {
  const byo = collectionId === "build-your-own";
  const tier = TIERS[collectionId]?.[size]?.price || 0;
  const extras = byo && size === "estate" ? Math.max(0, extraPumpkins || 0) * BYO.extraPumpkinPrice : 0;
  const items = Object.entries(addons).reduce((n, [k, q]) => n + itemPrice(k) * q, 0);
  const fee = byo ? BYO.designFee : 0;
  const prio = priority ? PRIORITY_REMOVAL.price : 0;
  return { tier, extras, items, fee, priority: prio, subtotal: tier + extras + items, total: tier + extras + items + fee + prio };
};

export const TIME_SLOTS = [
  "08:00-10:00",
  "10:00-12:00",
  "12:00-14:00",
  "14:00-16:00",
  "16:00-18:00",
  "18:00-20:00",
];

export const SEASON = {
  start: new Date(2026, 8, 1),
  end: new Date(2026, 10, 29, 23, 59, 59),
  label: "September 1 – November 29",
};

export const LEAD_HOURS = 16;
export const slotStart = (d, slot) => { const [h, m] = slot.split("-")[0].split(":").map(Number); const s = new Date(d); s.setHours(h, m, 0, 0); return s; };
export const slotTooSoon = (d, slot, now = new Date()) => slotStart(d, slot) < new Date(now.getTime() + LEAD_HOURS * 3600 * 1000);
export const isInstallDay = (d) => {
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const anyOpen = TIME_SLOTS.some((s) => !slotTooSoon(d, s));
  return d >= today && anyOpen && d >= SEASON.start && d <= SEASON.end && d.getDay() !== 0;
};

export const HOW_IT_WORKS = [
  { n: "01", title: "Choose a collection", text: "Begin with the palette that feels like home — or Build Your Own, piece by piece." },
  { n: "02", title: "Shape your porch", text: "Petite to Estate, then layer in extra pumpkins, mums, lanterns and more to suit your home." },
  { n: "03", title: "Reserve a time slot", text: "Choose an open two-hour time slot between September 1 and November 29, Monday through Saturday. Popular weeks are held early." },
  { n: "04", title: "Tell us about your home", text: "Your details and, if you like, a photo of the porch so we can compose the arrangement around it." },
  { n: "05", title: "Pay & it's booked", text: "Pay securely at checkout and your window is yours — a confirmation lands in your inbox straight away. Then we come and style." },
];

export const SEASON_FACTS = [
  { id: "season", value: "Sep–Nov", label: "One season a year" },
  { id: "days", value: "Mon–Sat", label: "Install days" },
  { id: "windows", value: "2 hrs", label: "Per install window" },
  { id: "closes", value: "Nov 29", label: "Final install date" },
];

export const TESTIMONIALS = [
  {
    name: "Aimee",
    when: "September 2026",
    quote:
      "I love my fall decorated porch!!! I've always wanted to go all out for fall but wasn't sure just how to make the space pop. Bella was very easy to work with and had a vision for my porch that did just that for me. She brought everything needed and made sure each item was cleaned well and properly placed to make my porch welcoming and festive. Thank you Bella for the beautiful porch decor.",
  },
  {
    name: "Rustin",
    when: "September 2026",
    quote:
      "We had the best experience with Pumpkin & Porch! Communication was seamless, and the final look on our porch is stunning. Such a great service — our home feels so ready for autumn now!",
  },
  { name: "Holly", when: "September 2026", quote: "It looks great!" },
];

export const PROMISES = [
  { caption: "Personal attention", title: "Every porch, styled by a person.", text: "Book in a few minutes, pay securely at checkout, and your date is yours. Then we look over your details and reach out if anything about your porch needs a closer look." },
  { caption: "Yours to keep", title: "Everything stays with you.", text: "Every pumpkin, mum and accent piece is yours for the season. Prefer not to take it down yourself? Add Priority Removal and we'll return in November to tidy the porch — guaranteed cleared by December 1." },
  { caption: "Made by hand", title: "Arranged on your porch, not dropped off.", text: "We set up each display in place, working around your steps and railings, so everything sits just right and looks lovely from the street." },
];

export const FAQS = [
  { q: "Do I need to be home for my installation?", a: "No, we just need access to your porch and we will have your display styled and ready to admire before you're even home." },
  { q: "What areas do we serve?", a: "We currently curate porches ranging from Salt Lake all the way down to Payson. Reach out today to see if you fall within our range!" },
  { q: "Do I get to keep the pumpkins?", a: "Absolutely. Every pumpkin, mum, and accent piece is yours to keep in full, a gift for your home to enjoy throughout the season, with nothing to return and no further visit required." },
  { q: "When is the best time to install?", a: "Our season runs September 1 through November 29. Most porches are styled from mid-September through October, and earlier dates fill quickly, so we recommend requesting your window a few weeks ahead." },
  { q: "How does pricing & payment work?", a: "Each package has a set price, with add-ons priced individually. You pay in full at checkout through Stripe's secure payment page, and your date is booked the moment payment clears. Refunds are available up to 5 days before your install." },
  { q: "Can I change my date after reserving?", a: "Of course. Open your reservation page and propose a new date, or reply to your confirmation email and we'll happily move your install to another open window." },
  { q: "Can I gift a porch to someone?", a: "Yes! Select \"This porch is a gift\" at checkout, add the recipient's name and address, and we'll handle the quote and payment with you while they enjoy the surprise." },
];

export const humanSlot = (s) => {
  const [a, b] = s.split("-");
  const h = (t) => {
    const [H, M] = t.split(":").map(Number);
    const ap = H >= 12 ? "pm" : "am";
    const hh = ((H + 11) % 12) + 1;
    return M === 0 ? `${hh}${ap}` : `${hh}:${String(M).padStart(2, "0")}${ap}`;
  };
  return `${h(a)}–${h(b)}`;
};

